<template>
    <div>
        <select-box-modal 
            v-if="isModal"
            :selectList="options"
            :selectedIndex="innerSelectedIndex"
            :title="title"
            @closeModal="closeModal"
            
        />
        <div name="select-box" class="select-box" @click="openModal">
            <span>{{selectedText}}</span>
            <img style="width: 13px;" src="../../assets/bottom_arrow.png" />
            
        </div>
    </div>

</template>

<script>
import SelectBoxModal from '@/components/modals/SelectBoxModal';

export default {
    name: 'selectBox',
    props: ['options', 'selectedIndex', 'placeHolder', 'title'],
    components: {
        SelectBoxModal
    },
    data: function()
    {
        return {
            selectedText: '',
            isModal: false,
            innerSelectedIndex: 0
        }
    },
    mounted: function()
    {
        this.innerSelectedIndex = this.selectedIndex;
        this.selectedText = this.placeHolder;
        if(this.selectedIndex !== -1)
        {
            this.selectedText = this.options[this.selectedIndex]; 
        }
    },
    methods: {
        closeModal: function(selected)
        {
            this.innerSelectedIndex = selected;
            if(selected !== -1)
            {              
                this.selectedText = this.options[this.innerSelectedIndex];                
            }
            this.isModal = false;
            
            this.$emit('select', this.innerSelectedIndex);
        },
        openModal: function()
        {
            this.isModal = true;
        }
    }
}
</script>

<style scoped>
    .select-box {
        width: 100%;
        height: 49px;
        flex-shrink: 0;
        border-radius: 6px;
        border: 1px solid var(--gray-40-button-stroke, #D1D6DB);
        background: var(--Gray-sub-color1, #F3F5F8);
        color: var(--Gray-50, #000);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 14px 0 20px;
        box-sizing: border-box;
    }
</style>


// WEBPACK FOOTER //
// src/components/atoms/SelectBox.vue